/**
 * Manual Metadata Configuration
 *
 * Configuration for all available help manuals.
 */

import type { ManualMetadata } from '../types/manual';
import type { UserRole } from '../types/index';

export const MANUALS_METADATA: ManualMetadata[] = [
  {
    id: 'member',
    title: '會員操作手冊',
    path: '/docs/delivery/01-會員操作手冊.md',
    requiredRole: 'member' as UserRole,
    icon: '📘',
    version: 'v0.12.0',
  },
  {
    id: 'admin',
    title: '管理員操作手冊',
    path: '/docs/delivery/02-管理員操作手冊.md',
    requiredRole: 'moderator' as UserRole,
    icon: '📕',
    version: 'v0.12.0',
  },
  {
    id: 'faq',
    title: '常見問題 FAQ',
    path: '/docs/delivery/03-常見問題-FAQ.md',
    requiredRole: 'member' as UserRole,
    icon: '❓',
    version: 'v0.8.0',
  },
  {
    id: 'account',
    title: '帳號資訊',
    path: '/docs/delivery/04-帳號資訊.md',
    requiredRole: 'super_admin' as UserRole,
    icon: '👤',
    version: 'v0.8.0',
  },
  {
    id: 'features',
    title: '功能清單',
    path: '/docs/delivery/05-功能清單.md',
    requiredRole: 'super_admin' as UserRole,
    icon: '📋',
    version: 'v0.8.0',
  },
  {
    id: 'environment',
    title: '系統環境說明',
    path: '/docs/delivery/06-系統環境說明.md',
    requiredRole: 'super_admin' as UserRole,
    icon: '⚙️',
    version: 'v0.8.0',
  },
];

/**
 * Get manuals available to a specific role
 */
export const getAvailableManuals = (userRole: UserRole): ManualMetadata[] => {
  const roleHierarchy: Record<UserRole, number> = {
    member: 1,
    moderator: 2,
    admin: 3,
    super_admin: 4,
  };

  return MANUALS_METADATA.filter((manual) => {
    const requiredLevel = roleHierarchy[manual.requiredRole];
    const userLevel = roleHierarchy[userRole];
    return userLevel >= requiredLevel;
  });
};

/**
 * Get manual metadata by ID
 */
export const getManualById = (id: string): ManualMetadata | undefined => {
  return MANUALS_METADATA.find((manual) => manual.id === id);
};

/**
 * Get default manual ID for a role
 */
export const getDefaultManualId = (userRole: UserRole): string => {
  const availableManuals = getAvailableManuals(userRole);
  return availableManuals.length > 0 ? availableManuals[0].id : 'member';
};
